/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.cv.assignments.rpc.RoutableTeamsService
 */

export const getRoutableTeamsRpc = {
  serviceName: 'com.hubspot.cv.assignments.rpc.RoutableTeamsService',
  rpcName: 'getRoutableTeams',
  auth: 'app',
  fingerprint: 'JEUzOhbLWZtr-L13FRKy1ceksKrxGavY',
  na1Only: false,
  isStreaming: false
};